/* tslint:disable */
/* eslint-disable */
/**
 * Kiwi Framework
 * Kiwi API description
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DocumentIdsForChat
 */
export interface DocumentIdsForChat {
    /**
     * 
     * @type {string}
     * @memberof DocumentIdsForChat
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentIdsForChat
     */
    fileName: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentIdsForChat
     */
    materialType: string;
}

/**
 * Check if a given object implements the DocumentIdsForChat interface.
 */
export function instanceOfDocumentIdsForChat(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "fileName" in value;
    isInstance = isInstance && "materialType" in value;

    return isInstance;
}

export function DocumentIdsForChatFromJSON(json: any): DocumentIdsForChat {
    return DocumentIdsForChatFromJSONTyped(json, false);
}

export function DocumentIdsForChatFromJSONTyped(json: any, ignoreDiscriminator: boolean): DocumentIdsForChat {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'fileName': json['fileName'],
        'materialType': json['materialType'],
    };
}

export function DocumentIdsForChatToJSON(value?: DocumentIdsForChat | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'fileName': value.fileName,
        'materialType': value.materialType,
    };
}

